import React, { FC } from 'react';
import { ReactComponent as DeliveredIcon } from 'src/assets/images/delivered-icon.svg';
import { ReactComponent as InProgressIcon } from 'src/assets/images/in-progress-icon.svg';
import styled from 'styled-components';
import { DeliveredStatus, InProgressStatus } from '../../styles/colours';
import { Medium } from '../../styles/fonts';

const Status = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;

  font-family: ${Medium};
`;
const DeliveryStatus = styled(Status)`
  color: ${DeliveredStatus};
`;
const DeliveryInProgressStatus = styled(Status)`
  color: ${InProgressStatus};
`;
const StatusLabel = styled.div`
  padding-left: 0.5rem;
  padding-right: 1rem;
`;

export const Delivered = () => {
  return (
    <DeliveryStatus>
      <DeliveredIcon />
      <StatusLabel>Delivered</StatusLabel>
    </DeliveryStatus>
  );
};
export const InProgress = () => {
  return (
    <DeliveryInProgressStatus>
      <InProgressIcon />
      <StatusLabel>In progress</StatusLabel>
    </DeliveryInProgressStatus>
  );
};
export const TMSUpdate: FC<{ update: string }> = ({ update }) => {
  return (
    <DeliveryInProgressStatus>
      <InProgressIcon />
      <StatusLabel>{update}</StatusLabel>
    </DeliveryInProgressStatus>
  );
};
